/* eslint-disable no-invalid-this */
/* eslint-disable max-len */
/* eslint-disable no-unused-vars */
// CONSTANTS are all caps.
const NS = 'GalleryCarousel';
const CLS = 'galleryCarousel';
const WG = `.${CLS}-`;

// Import stuff here if you need to or even better to import them dynamically
// for ex. of dynamic import check out src/scripts/loadWg/galleryCarousel.js using Webpack dynamic imports as chunks.
// import $ from 'jquery'

// Polyfill object-fit/object-position on <img>: IE9, IE10, IE11, Edge, Safari, ... @https://npm.im/object-fit-images
import objectFitImages from 'object-fit-images';
import utils from '../utils';


export class GalleryCarousel {
	constructor($el) {
		// $el is the widget node return by the loadGalleryCarousel function
		this.$el = $($el);
		this.isWpc = $('body').hasClass('is-wpc');
	}

	init() {
		let $carousel = this.$el.find(`${WG}carousel`);
		let $wg = this.$el;
		let _this = this;
		let navActiveClass = 'is-active';
		this.checkImage();

		$carousel.on('init', (slick) => {
			this.setLandscapeImage();
			this.handleLongCaption();

			this.$el.find('.sliderNav-link').on('click', function() {
				let $this = $(this);
				let index = $this.attr('data-slide-index');

				$carousel.slick('slickGoTo', index);
				$this.siblings().removeClass(navActiveClass);
				$this.addClass(navActiveClass);

				// detach the line and put it before the active item
				let $sliderNavLine = $wg.find('.sliderNav-line').detach();
				$this.before($sliderNavLine);
			});
		}).slick({
			arrows: this.isWpc ? true : false,
			dots: this.isWpc ? true : false,
			centerMode: true,
			centerPadding: '26.1%',
			appendDots: this.$el.find(`${WG}carouselDots`),
			draggable: true,
			slidesToShow: 1,
			variableWidth: true,
			responsive: [
				{
					breakpoint: 991,
					settings: {
						centerPadding: '15%',
					},
				},
				{
					breakpoint: 767,
					settings: {
						centerPadding: '15%',
						variableWidth: true,
						dots: true,
						adaptiveHeight: true, // Added to fix "Mobile – The gallery circle indicators should sit closer to the image/caption"
					},
				},
			],
		}).on('afterChange', (event, slick, currentSlide) => {
			let $sliderNavLine = $wg.find('.sliderNav-line').detach();
			this.$el.find(`.sliderNav-link`).removeClass(navActiveClass);
			this.$el.find(`.sliderNav-link[data-slide-index=${currentSlide}]`).addClass(navActiveClass).before($sliderNavLine);
		});

		// Polyfill object-fit/object-position on <img>: IE9, IE10, IE11, Edge, Safari, ... @https://npm.im/object-fit-images

		objectFitImages();
		this.handleWindowResize();

		this.handleSlidesLinks();
	}

	handleWindowResize() {
		$(window).on('resize', () => {
			this.setLandscapeImage();
			this.handleLongCaption();
		});
	}

	// handle long caption by setting width to caption based on image's width
	handleLongCaption() {
		let $wg = this.$el;
		let carouselW = $wg.find(`${WG}carousel`).outerWidth();

		$wg.find(`${WG}slide`).each((i, slide) => {
			let $imgWrap = $(slide).find(`${WG}slideImgWrap`);
			let $caption = $(slide).find(`${WG}carouselCaption`);

			let captionHtml = $caption.html();
			$caption.html('');

			let imgW = `${$imgWrap.outerWidth()}px`;
			$caption.css({
				width: imgW,
				maxWidth: `${carouselW}px`,
			});
			$caption.html(captionHtml);
		});
	}

	// check image is landscape or portrait, then add "--landscape" modifier if true
	checkImage() {
		let $wg = this.$el;

		$wg.find(`${WG}slideImg`).each((i, img) => {
			let imgH = img.naturalHeight;
			let imgW = img.naturalWidth;

			if (imgW > imgH) {
				$(img).closest(`${WG}slide`).addClass(`${CLS}-slide--landscape`);
			}
		});
	}

	// set slick slide's width on mobile
	setLandscapeImage() {
		let $wg = this.$el;
		let wgW = $wg.outerWidth();

		if (utils.checkBP('tp')) {
			$wg.find(`${WG}slide`).each((i, slide) => {
				let $slide = $(slide);
				let $slickSlide = $slide.closest('.slick-slide');
				let newW = wgW - (wgW * 40/100);

				// check if image is landscape
				if ($slide.hasClass(`${CLS}-slide--landscape`)) {
					$slickSlide.css({
						maxWidth: `${wgW - 30}px`,
					});

					$slide.find(`${WG}slideImgWrap`).css({
						height: 'auto',
					});
				} else {
					$slickSlide.css({
						maxWidth: `${newW}px`,
					});
				}
			});
		} else {
			$wg.find(`.slick-slide`).css({
				maxWidth: '',
			});

			$wg.find(`${WG}slideImgWrap`).css({
				height: '',
			});
		}
	}

	handleSlidesLinks() {
		let $wg = this.$el;
		let $modal = $wg.find(WG + 'modal').clone();
		let $iframe = $modal.find('iframe');

		let closeIframe = function() {
			$modal.removeClass('active').remove();

			$iframe.attr('src', '');
		};

		$wg.on('click', WG + 'slideLink', function(e) {
			if ($(this).data('iframe')) {
				e.preventDefault();

				$iframe.attr('src', $(this).attr('href'));

				$('body').append($modal);

				$modal.addClass('active');
			}
		});

		$(document).on('click', WG + 'modal-close,' + WG + 'modal', function(e) {
			let $this = $(this);

			if ($this.closest(WG + 'modal-content').length === 0) {
				closeIframe();
			}
		});
	}
}
